import { render } from "./LayoutList.vue?vue&type=template&id=5f9e0a76&scoped=true"
import script from "./LayoutList.vue?vue&type=script&lang=js"
export * from "./LayoutList.vue?vue&type=script&lang=js"

import "./LayoutList.vue?vue&type=style&index=0&id=5f9e0a76&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9e0a76"]])

export default __exports__